export function MessageNotice({
  copy,
  onRetry,
}: {
  readonly copy: string;
  readonly onRetry?: () => void;
}) {
  return (
    <div className="messages-notice" role="alert">
      <p>{copy}</p>
      {onRetry !== undefined ? (
        <button type="button" onClick={onRetry}>Try again</button>
      ) : null}
    </div>
  );
}
